/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    facilityDataReducers,
    initialState as facilityInitialState,
} from './facilityDataReducers';

import {
    reviewSummaryReducers,
    initialState as reviewSummaryInitialState,
} from './reviewSummaryReducers';

import {
    facilityImagesReducers,
    initialState as facilityImagesInitialState,
} from './facilityImagesReducers';

import { recAreaReducers, initialState as recAreaInitialState } from './recAreaReducers';

import {
    toursDataReducers,
    initialState as toursInitialState,
} from './toursDataReducers';

import {
    tourImagesReducers,
    initialState as tourImagesInitialState,
} from './tourImagesReducers';

import {
    pricingViewReducers,
    initialState as pricingViewInitialState,
} from './pricingViewReducers';

import {
    tourRatingsReducers,
    initialState as tourRatingsInitialState,
} from './tourRatingsReducers';

import {
    facilityAvailabilityReducers,
    initialState as facilityAvailabilityInitialState,
} from './facilityAvailabilityReducers';

import {
    tourTimesReducers,
    initialState as tourTimesInitialState,
} from './tourTimesReducers';

import {
    tourAvailabilityReducers,
    initialState as tourAvailabilityInitialState,
} from './tourAvailabilityReducers';

import {
    accountTypeReducers,
    initialState as accountTypeInitialState,
} from './accountTypeReducers';

import { orderDetailsInitialState, orderDetailsReducers } from './orderDetailsReducers';

import { filters, initialState as filtersInitialState } from './filtersReducers';

import {
    availabilityAlertsReducers,
    initialState as availabilityAlertsInitialState,
} from '../shared/reducers';

const initialState = {
    accountType: accountTypeInitialState,
    facility: facilityInitialState,
    facilityImages: facilityImagesInitialState,
    reviewSummary: reviewSummaryInitialState,
    recArea: recAreaInitialState,
    tours: toursInitialState,
    tourImages: tourImagesInitialState,
    tourRatings: tourRatingsInitialState,
    pricingView: pricingViewInitialState,
    facilityAvailability: facilityAvailabilityInitialState,
    tourTimes: tourTimesInitialState,
    tourAvailability: tourAvailabilityInitialState,
    filters: filtersInitialState,
    orderDetails: orderDetailsInitialState,
    availabilityAlerts: availabilityAlertsInitialState,
};

export function timedEntryReducers(state = initialState, action) {
    const reducers = {
        ...state,
        accountType: accountTypeReducers(state.accountType, action),
        facility: facilityDataReducers(state.facility, action),
        facilityAvailability: facilityAvailabilityReducers(
            state.facilityAvailability,
            action
        ),
        facilityImages: facilityImagesReducers(state.facilityImages, action),
        reviewSummary: reviewSummaryReducers(state.reviewSummary, action),
        recArea: recAreaReducers(state.recArea, action),
        tours: toursDataReducers(state.tours, action),
        tourImages: tourImagesReducers(state.tourImages, action),
        tourAvailability: tourAvailabilityReducers(state.tourAvailability, action),
        tourRatings: tourRatingsReducers(state.tourRatings, action),
        pricingView: pricingViewReducers(state.pricingView, action),
        tourTimes: tourTimesReducers(state.tourTimes, action),
        filters: filters(state.filters, action),
        orderDetails: orderDetailsReducers(state.orderDetails, action),
        availabilityAlerts: availabilityAlertsReducers(state.availabilityAlerts, action),
    };

    return reducers;
}
